import './Search.scss';
import Component from './Search.js';
export default Component;
